/**
 * SYNC User Flight Credit Action
 *
 * Triggers a manual re-sync of a single flight credit from Magnatech.
 * Follows the same dispatch/API_CALL pattern as SyncDuffelBooking.tsx.
 */
import {
  ACTION_SYNC_USER_FLIGHTCREDIT,
  ACTION_SYNC_USER_FLIGHTCREDIT_SUCCESS,
  ACTION_SYNC_USER_FLIGHTCREDIT_FAILURE,
  API_CALL,
} from '../../configs/ActionTypes';
import { Dispatch } from 'redux';
import { enqueueSnackbarHandler } from '../Status';
import * as _ from 'lodash-es';

export function syncUserFlightCredit(id: string) {
  return (dispatch: Dispatch, getState: Function) => {
    dispatch(requestStarted());

    dispatch({
      type: API_CALL,
      payload: {
        call: `user/flight-credits/sync`,
        method: 'post',
        data: JSON.stringify({ id }),
        success: (response: any) => {
          const isFailure =
            response?.type === 'error' ||
            _.get(response, 'payload.success', true) === false;

          if (isFailure) {
            dispatch(requestFailed(response));
            _.get(response.payload.payload, 'userPermissionError', false)
              ? enqueueSnackbarHandler(
                  dispatch,
                  response.payload.payload,
                  'error',
                )
              : enqueueSnackbarHandler(
                  dispatch,
                  { syncFlightCreditFailed: true },
                  'error',
                );
          } else {
            dispatch(
              requestSuccess({
                id,
                updatedCredit: _.get(
                  response,
                  'payload.updatedCredit',
                  null,
                ),
                syncedCredit: _.get(response, 'payload.syncedCredit', null),
              }),
            );
            enqueueSnackbarHandler(
              dispatch,
              { syncFlightCreditSuccess: true },
              'success',
            );
          }
        },
        fail: (error: any) => {
          _.get(error.payload, 'userPermissionError', false)
            ? enqueueSnackbarHandler(dispatch, error.payload, 'error')
            : enqueueSnackbarHandler(
                dispatch,
                { syncFlightCreditFailed: true },
                'error',
              );
          dispatch(requestFailed(error));
        },
      },
    });

    return null;
  };
}

export function requestStarted() {
  return {
    type: ACTION_SYNC_USER_FLIGHTCREDIT,
    payload: null,
  };
}

export function requestSuccess(responseJSON: object) {
  return {
    type: ACTION_SYNC_USER_FLIGHTCREDIT_SUCCESS,
    payload: responseJSON,
  };
}

export function requestFailed(responseJSON: object) {
  return {
    type: ACTION_SYNC_USER_FLIGHTCREDIT_FAILURE,
    payload: responseJSON,
  };
}
